(function(){
  'use strict';

  var containerSelector = '.fnx-live-commerce-state';
  var rootSelector = ':scope > .fnx-self,:scope > .fnx-wrap,:scope > .fx,:scope > div[style]';
  var introSelectors = [
    ':scope > .fnx-presentation',
    ':scope > .fh',
    ':scope > .hero',
    ':scope > .fnx-h'
  ];
  var essentialSelectors = [
    ':scope > .fnx-quick',
    ':scope > .fs',
    ':scope > .quick',
    ':scope > .fnx-qk'
  ];
  var deepSelectors = [
    ':scope > .fnx-deep',
    ':scope > details.fnx-d',
    ':scope > details.deep',
    ':scope > details'
  ];

  function firstMatch(root,selectors){
    for(var index=0;index<selectors.length;index+=1){
      try{
        var match = root.querySelector(selectors[index]);
        if(match){return match;}
      }catch(error){
        continue;
      }
    }
    return null;
  }

  function markSection(node,name,step,label){
    if(!node){return;}
    node.dataset.fnx24Section = name;
    node.dataset.fnx24Step = step;
    node.setAttribute('role','region');
    node.setAttribute('aria-label',label);
  }

  function retireDuplicateClose(root){
    root.querySelectorAll('.fnx-close,.fnx-end').forEach(function(node){
      node.classList.add('fnx24-admin-close-retired');
      node.hidden = true;
      node.setAttribute('aria-hidden','true');
    });
  }

  function refineDeep(deep){
    if(!deep || deep.tagName !== 'DETAILS'){return;}
    var summary = deep.querySelector(':scope > summary');
    var target = window.location.hash ? document.querySelector(window.location.hash) : null;
    if(target && deep.contains(target)){
      deep.open = true;
    }else{
      deep.open = false;
    }
    deep.classList.toggle('is-open',deep.open);
    deep.addEventListener('toggle',function(){
      deep.classList.toggle('is-open',deep.open);
    });
    if(!summary){return;}
    var title = summary.querySelector('strong');
    if(title && /^\s*profundiza\s*$/i.test(title.textContent || '')){
      title.textContent = 'PROFUNDIZA CUANDO QUIERAS';
    }
    if(!summary.querySelector('.fnx-arrow')){
      var arrow = document.createElement('span');
      arrow.className = 'fnx-arrow';
      arrow.setAttribute('aria-hidden','true');
      arrow.textContent = '↓';
      summary.appendChild(arrow);
    }
  }

  function enhanceContainer(container){
    if(!container || container.dataset.fnx24Structured === 'true'){return;}
    var root = null;
    try{root = container.querySelector(rootSelector);}catch(error){root = container.firstElementChild;}
    if(!root || root.tagName === 'STYLE'){
      root = Array.prototype.find.call(container.children,function(node){return node.tagName !== 'STYLE';}) || null;
    }
    if(!root){return;}

    container.dataset.fnx24Structured = 'true';
    root.dataset.fnx24Pdp = 'true';

    var intro = firstMatch(root,introSelectors);
    var essential = firstMatch(root,essentialSelectors);
    var deep = firstMatch(root,deepSelectors);

    markSection(intro,'intro','01','Introducción');
    markSection(essential,'essential','02','Lo esencial en segundos');
    markSection(deep,'deep','03','Profundiza cuando quieras');
    refineDeep(deep);
    retireDuplicateClose(root);

    var complete = Boolean(intro && essential && deep);
    root.dataset.fnx24Layout = complete ? 'complete' : 'legacy';
    if(!root.classList.contains('fnx-self') && !root.classList.contains('fnx-wrap') && !root.classList.contains('fx')){
      root.dataset.fnx24Fallback = 'inline';
    }
  }

  function run(root){
    var scope = root || document;
    if(scope.matches && scope.matches(containerSelector)){enhanceContainer(scope);}
    scope.querySelectorAll(containerSelector).forEach(enhanceContainer);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){run(document);},{once:true});
  }else{
    run(document);
  }

  if('MutationObserver' in window){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(node && node.nodeType === 1){run(node);}
        });
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();

